// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2q-76","logo":"Footer_logo__24uoo","content":"Footer_content__3RFM3","iconContainer":"Footer_iconContainer__XWLpQ","infoText":"Footer_infoText__122xd"};